import React from "react";
import cx from "classnames";
const BreadCrumbs = ({ children, containerClass, seperatorClass }) => {
  return (
    <div className={cx(" flex gap-x-4 text-[14px]", containerClass)}>
      {Array.isArray(children) ? (
        children.map((child, index) => (
          <React.Fragment key={index}>
            {child}
            {children.length - 1 !== index && (
              <span className={seperatorClass}>/</span>
            )}
          </React.Fragment>
        ))
      ) : (
        <React.Fragment>
          {children} <span className={seperatorClass}>/</span>
        </React.Fragment>
      )}
    </div>
  );
};

export default BreadCrumbs;
